exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.question[data-v-492d11d2] {\n  padding-bottom: 20px;\n  margin-bottom: 40px;\n  border-bottom: 1px solid #e0e0e0;\n}\n", ""]);

// exports
